import { Stack, Typography, Paper, Chip } from '@mui/material';

import { useUploaderContext } from '@/context/UploaderProvider';
import { useTranslationPrefix } from '@/translations/i18n';

export const UploadInProgressView = () => {
  const t = useTranslationPrefix('uploader');
  const { streamingIssue } = useUploaderContext();

  // Shared chip style
  const chipBaseStyle = {
    display: 'flex',
    color: 'var(--tx-text)',
    height: '25px',
    width: '170px',
    padding: '8px 20px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
    borderRadius: '10px',
    textAlign: 'center',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '14px',
  };

  // Severity-specific styles
  const severityStyles = {
    Critical: { ...chipBaseStyle, bgcolor: '#B05670' },
    Moderate: { ...chipBaseStyle, bgcolor: '#EFC46C' },
    Urgent: { ...chipBaseStyle, bgcolor: '#E88F67' },
    Low: { ...chipBaseStyle, bgcolor: '#7ABFB8' },
    Monitor: { ...chipBaseStyle, bgcolor: '#BBB7AF' },
  };

  return (
    <Stack width="100%" alignItems="center">
      {/* Success Icon - Green Circle with Checkmark */}

      {/* All Set Heading */}
      <Typography variant="h4" fontWeight="600" lineHeight={1.35} sx={{ mb: 2 }}>
        {t('step_title.4')}
      </Typography>

      {/* Subtitle */}
      <Typography
        textAlign="center"
        color="text.secondary"
        variant="h6"
        fontWeight="regular"
        lineHeight={1.35}>
        {t('step_subtitle.4')}
      </Typography>

      {/* Property Info Card */}
      <Paper
        sx={{
          width: '370px',
          bgcolor: 'background.paper',
          p: 3,
          borderRadius: 2,
          paddingTop: 8,
        }}>
        <Stack alignItems="center" mb={2} pt={8}>
          <Chip
            label={`${streamingIssue?.urgency?.toUpperCase() || ''}`}
            sx={severityStyles[streamingIssue?.urgency || 'Monitor']}
          />
        </Stack>
        <Stack spacing={1} mb={4} pt={6} alignItems="center">
          <Typography variant="h6" fontWeight="500" sx={{ color: 'white' }}>
            {streamingIssue?.title}
          </Typography>

          {/* Subtitle */}
          <Typography
            textAlign="center"
            color="text.secondary"
            sx={{
              maxWidth: 300,
              paddingTop: 0,
              color: 'var(--tx-muted)',
              fontFamily: 'Manrope',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 'normal',
            }}>
            {streamingIssue?.description}
          </Typography>
        </Stack>
      </Paper>
    </Stack>
  );
};
